import { enableAutoTrack, makeTracker } from './auto';
import { type EventArgs, type Events } from './events';
import { mixpanel } from './mixpanel';
export const track = makeTracker((event, props) => {
  mixpanel.track(event, props);
});

export { enableAutoTrack, type EventArgs, type Events, mixpanel };
export default track;
